// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"8d77d40d","99":"cbc0ff06","365":"383f2ea5","455":"b7a64b98","850":"a32d34c9"}[chunkId] + ".js";
};